export default __webpack_public_path__ + "static/media/imc-2024.324127d6.png";